module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/按钮-攻略专区入口.a18aa.png";